import React from 'react';
import './WidgetSkeleton.css';

/**
 * Generic, low-key loading skeleton. Renders a small stack of shimmering
 * placeholder bars centered in the tile — content-shape agnostic, so it
 * works for gauges, tables, charts, maps, etc. without misleading the user.
 */
const WidgetSkeleton = () => (
  <div
    className="widget-skeleton"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div className="widget-skeleton__bars">
      <div className="widget-skeleton__bar widget-skeleton__bar--short" />
      <div className="widget-skeleton__bar" />
      <div className="widget-skeleton__bar widget-skeleton__bar--medium" />
    </div>
    <span className="sr-only">Loading…</span>
  </div>
);

export default WidgetSkeleton;
